import homeInfoBox from "./home-info-box";
import shortcutCards from "./shortcut-cards";
import articleNews from "./article-news";
const modul = angular
    .module("HomeComponents", [])

    .directive("articleNews", articleNews)
    .directive("homeInfoBox", homeInfoBox)

    .directive("shortcutCards", shortcutCards);

export default modul.name;
